"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercent = exports.formatCurrency = void 0;
const formatNumber = (number, options = {}) => {
    if (number === 0) {
        return number.toLocaleString('en-US', options);
    }
    return number && number.toLocaleString('en-US', options);
};
exports.default = formatNumber;
exports.formatCurrency = (number, currency, maximumFractionDigits = 2) => {
    return formatNumber(Number.parseFloat(number), {
        style: 'currency',
        currency,
        maximumFractionDigits,
    });
};
exports.formatPercent = number => {
    if (number >= 0.999 && number < 1)
        number = 0.999;
    return formatNumber(number, { style: 'percent', maximumFractionDigits: 1 });
};
//# sourceMappingURL=formatNumber.js.map